export const formatNumber = (n, precision = 0) =>
  n.toFixed(precision).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
